/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
initApp();
function initApp() {
  const countDownPlace2 = document.querySelector(
    "#shipping-estimate--delivery-date"
  );
  const countrySelector = document.querySelector("#country");
  const timezoneSelector = document.querySelector("#timezone");
  const divFlotante = document.querySelector("#div-flotante");
  const divDinamico1 = document.querySelector("#div-dinamico");

  function iniciarCountdownyFechaEntrega() {
    const divPadreContenidoBarra = document.querySelector("#divBold");
    var today = new Date();

    divPadreContenidoBarra.addEventListener("mouseover", () => {
      divFlotante.style.display = "block";
    });

    divPadreContenidoBarra.addEventListener("mouseout", () => {
      divFlotante.style.display = "none";
    });

    function countDownTimer() {
      //Calcular diferencia entre hora actual y hora limite en UTC
      var horaActualUTC = new Date(
        new Date().toLocaleString("en-US", { timeZone: "Europe/Madrid" })
      );
      var horaLimite = new Date(horaActualUTC);

      // Establece la hora límite en 17:30 UTC
      horaLimite.setUTCHours(17);
      horaLimite.setUTCMinutes(30);
      horaLimite.setUTCSeconds(0);
      horaLimite.setUTCMilliseconds(0);

      //Pasar a milisegundos para la resta
      var milisegundosHoraLimite = horaLimite.getTime();
      var milisegundoshoraActual = today.getTime();

      var diferenciaTiempo = milisegundosHoraLimite - milisegundoshoraActual;

      //Pasar los milisegundos a tiempo para la cuenta atrás
      var countDown = new Date(diferenciaTiempo);

      var horas = countDown.getUTCHours();
      var minutos = countDown.getUTCMinutes();
      var segundos = countDown.getUTCSeconds();

      //Insertar tiempo en HTML
      const countDownPlace = document.querySelector(
        "#shipping-estimate--time-left"
      );
      countDownPlace.innerHTML = `${horas} hours ${minutos} minutes ${segundos} seconds`;
    }
  }

  function obtenerDias() {
    const url = "http://worldtimeapi.org/api/ip";
    fetch(url)
      .then((respuesta) => respuesta.json())
      .then((resultado) => obtenerDatosAPI(resultado));

    function obtenerDatosAPI(times) {
      const { day_of_week, timezone, client_ip } = times;

      timezoneSelector.innerHTML = `${timezone}`;

      // Obtener pais del cliente a través de API
      const url = `https://api.iplocation.net/?ip=${client_ip}`;
      fetch(url)
        .then((respuesta) => respuesta.json())
        .then((resultado) => calcularFechaDeEntrega(resultado.country_name));

      function calcularFechaDeEntrega(pais) {
        //Entrega Mañana
        var hoy = new Date();
        const horaActual = hoy.getUTCHours();
        const minutosActual = hoy.getUTCMinutes();

        //Meter datos en div
        //pais = 'Netherlands';
        countrySelector.innerHTML = `${pais}`;
        countrySelector.style.marginBottom = "-5px";

        const horaLimiteEntrega = 17;
        const minutosLimiteEntrega = 30;

        //HOLANDA
        if (pais === "Netherlands") {
          //DOMINGO-VIERNES
          if (
            (day_of_week === 1 &&
              (horaActual < horaLimiteEntrega ||
                (horaActual <= horaLimiteEntrega &&
                  minutosActual < minutosLimiteEntrega))) ||
            (day_of_week === 2 &&
              (horaActual < horaLimiteEntrega ||
                (horaActual <= horaLimiteEntrega &&
                  minutosActual < minutosLimiteEntrega))) ||
            (day_of_week === 3 &&
              (horaActual < horaLimiteEntrega ||
                (horaActual <= horaLimiteEntrega &&
                  minutosActual < minutosLimiteEntrega))) ||
            (day_of_week === 4 &&
              (horaActual < horaLimiteEntrega ||
                (horaActual <= horaLimiteEntrega &&
                  minutosActual < minutosLimiteEntrega))) ||
            (day_of_week === 0 &&
              (horaActual < horaLimiteEntrega ||
                (horaActual <= horaLimiteEntrega &&
                  minutosActual < minutosLimiteEntrega))) ||
            (day_of_week === 5 &&
              (horaActual < horaLimiteEntrega ||
                (horaActual <= horaLimiteEntrega &&
                  minutosActual < minutosLimiteEntrega)))
          ) {
            var fechaTomorrow = new Date(hoy);
            fechaTomorrow.setDate(hoy.getDate() + 1);
            formatearFechas(fechaTomorrow);
            divDinamico1.style.padding = "0px 45px";
            insertPostNL();

            //SABADO
          } else {
            var fecha2Dias = new Date(hoy);
            fecha2Dias.setDate(hoy.getDate() + 2);
            formatearFechas(fecha2Dias);
            divDinamico1.style.padding = "0px 45px";
            insertPostNL();
          }
        } else {
          //RESTO EUROPA
          //DOMINGO-JUEVES
          if (
            (day_of_week === 1 &&
              (horaActual < horaLimiteEntrega ||
                (horaActual <= horaLimiteEntrega &&
                  minutosActual < minutosLimiteEntrega))) ||
            (day_of_week === 2 &&
              (horaActual < horaLimiteEntrega ||
                (horaActual <= horaLimiteEntrega &&
                  minutosActual < minutosLimiteEntrega))) ||
            (day_of_week === 3 &&
              (horaActual < horaLimiteEntrega ||
                (horaActual <= horaLimiteEntrega &&
                  minutosActual < minutosLimiteEntrega))) ||
            (day_of_week === 4 &&
              (horaActual < horaLimiteEntrega ||
                (horaActual <= horaLimiteEntrega &&
                  minutosActual < minutosLimiteEntrega)))
          ) {
            var fechaTomorrow = new Date(hoy);
            fechaTomorrow.setDate(hoy.getDate() + 1);
            formatearFechas(fechaTomorrow);

            //VIERNES
          } else if (day_of_week === 5) {
            var fecha4Dias = new Date(hoy);
            fecha4Dias.setDate(hoy.getDate() + 4);
            formatearFechas(fecha4Dias);
            //SABADO
          } else if (day_of_week === 6) {
            var fecha3Dias = new Date(hoy);
            fecha3Dias.setDate(hoy.getDate() + 3);
            formatearFechas(fecha3Dias);
            //DOMINGO
          } else {
            var fecha2Dias = new Date(hoy);
            fecha2Dias.setDate(hoy.getDate() + 2);
            formatearFechas(fecha2Dias);
          }
        }
      }
    }
    //Devolver fecha en formato correcto
    function formatearFechas(fecha) {
      fecha.toLocaleString("EN", { month: "long" });
      const fechaFormateada = `${fecha.getDate()} of ${fecha.toLocaleString(
        "EN",
        { month: "long" }
      )}`;
      meterFechaBarra(fechaFormateada);
    }
    //Meter fecha en barra y countdowns
    function meterFechaBarra(fechaLista) {
      const moreInfoTexto = document.createElement("SPAN");
      moreInfoTexto.textContent = " (more info here)";
      countDownPlace2.innerHTML = `${fechaLista}`;
      countDownPlace2.style.textDecorationLine = "underline";
      if (divPadreContenidoBarra.childElementCount <= 1) {
        divPadreContenidoBarra.appendChild(moreInfoTexto);
      }
    }
  }
  function insertPostNL() {
    const divPostNL = document.createElement("DIV");
    divPostNL.style.add = "countdown-post-nl";
    if (divDinamico1.childElementCount <= 2) {
      divDinamico1.innerHTML += `
      <div class="countdown-post-nl">
        <img style="width: 35px; height:40px" src="https://cdn.shopify.com/s/files/1/0571/7475/3429/files/pngwing.com_c960388c-da72-4022-bdd6-231e56eb39f1.png?v=1685697283">
        <div style="margin-left: 18px;">
          <h5 style="color: black; margin-top: -10px; margin-bottom: -5px; font-size:14px; font-weight: bold;">Post NL</h5>
          <p style="color: black; font-size: 12px; margin-bottom: -5px;">24/48 Hours delivery</p>
          <p style="color: black; font-size: 12px;">Monday to Saturday</p>
        </div>
      </div>
    `;
    }
  }
}

setTimeout(() => {
  cambiadorVat();
  function cambiadorVat() {
    const vatChanger = document.querySelector("#vat-changer");

    if (vatChanger != null) {
      vatChanger.style.backgroundColor = "#f06429";
      const lineTableCart = document.querySelectorAll(".line-item--stack");

      vatChanger.addEventListener("click", () => {
        addVatCollection();
        addVatCart();
      });

      function addVatCollection() {
        const prices = document.querySelectorAll(".price");
        // VAT ON
        if (vatChanger.textContent === "VAT EXCLUDED") {
          vatChanger.textContent = "VAT INCLUDED";

          prices.forEach((precioOriginal) => {
            const precioNumber = Number(
              precioOriginal.textContent.replace("€", "").replace(",", ".")
            );
            const numberWithVat = precioNumber * 1.21;
            precioOriginal.innerHTML = `€${numberWithVat
              .toFixed(2)
              .replace(".", ",")}`;
          });
          // VAT OFF
        } else {
          vatChanger.textContent = "VAT EXCLUDED";

          prices.forEach((precioOriginal) => {
            const precioNumber = Number(
              precioOriginal.textContent.replace("€", "").replace(",", ".")
            );
            const numberWithVat = precioNumber / 1.21;
            precioOriginal.innerHTML = `€${numberWithVat
              .toFixed(2)
              .replace(".", ",")}`;
          });
        }
      }
      function addVatCart() {
        // VAT ON
        if (vatChanger.textContent === "VAT INCLUDED") {
          lineTableCart.forEach((productCart) => {
            const precioOriginalCart = Number(
              productCart.children[2].firstElementChild.textContent
                .replace("€", "")
                .replace(",", ".")
            );
            const numberWithVatCart = precioOriginalCart * 1.21;

            const divInsertPrice = productCart.children[2].firstElementChild;

            divInsertPrice.innerHTML = `€${numberWithVatCart.toFixed(2)}`;
          });
          // VAT OFF
        } else {
          lineTableCart.forEach((productCart) => {
            const precioOriginalCart = Number(
              productCart.children[2].firstElementChild.textContent
                .replace("€", "")
                .replace(",", ".")
            );
            const numberWithVatCart = precioOriginalCart / 1.21;

            const divInsertPrice = productCart.children[2].firstElementChild;

            divInsertPrice.innerHTML = `€${numberWithVatCart.toFixed(2)}`;
          });
        }
      }
    }
  }
}, "3000");

document
  .querySelectorAll('[href="https://4phdepotones.com/pages/contactus"]')
  .forEach(function (link) {
    link.addEventListener("click", function (e) {
      e.preventDefault();
      window.Trengo.Api.Widget.open("chat");
    });
  });

// const apiEndpoint = 'https://aleksa.eu.ngrok.io/'
// const apiEndpoint = 'https://app-77c312c4-5d2c-430f-b9b1-b110e4f1abb8.cleverapps.io'
let apiEndpoint = "https://four-phones-8mw7q.ondigitalocean.app";

function handleCustomerAdditionalTaxSubmit(e) {
  e.preventDefault();
  e.stopPropagation();
  let line_items = [];
  let cartData = {};
  const { customer } = JSON.parse(
    document.querySelector("[data-customer-json]").innerHTML
  );

  fetch("/cart.js")
    .then(function (res) {
      return res.json();
    })
    .then(function ({ items }) {
      for (var i = 0; i < items.length; i++) {
        const { variant_id, quantity, final_price, properties } = items[i];
        let propertiesArray = [];

        if (properties != null) {
          for (const [key, value] of Object.entries(properties)) {
            propertiesArray.push({
              key: value,
            });
          }
        }

        line_items.push({
          variant_id,
          quantity,
          price_single: final_price,
          properties: propertiesArray,
        });
      }

      cartData.line_items = line_items;
      cartData.customer = customer;

      fetch(apiEndpoint + "/api/addTax", {
        method: "POST",
        credentials: "same-origin",
        body: JSON.stringify(cartData),
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (res) {
          localStorage.setItem("orderId", JSON.stringify(res.orderId));
          localStorage.setItem("lineItems", JSON.stringify(res.lineItems));
          location.href = res.url + "?locale=" + Shopify.locale;
        })
        .catch(function (error) {
          console.log("catch error", error);
        });
    });
}

document
  .querySelectorAll(".js-req-checkout")
  .forEach(function (checkoutButton) {
    checkoutButton.addEventListener("click", function (event) {
      event.preventDefault();
      event.stopPropagation();
      handleCustomerAdditionalTaxSubmit(event);
    });
  });

function isCookieSet(value) {
  return document.cookie.split(";").some(function (item) {
    return item.trim().indexOf(value) === 0;
  });
}

function setPriceVatVisibility(value) {
  const date = new Date(new Date().getTime() + 1000 * 60 * 60 * 24);
  if (value) {
    // we're overwriting the value
    document.querySelector("body").setAttribute("data-prices-with-vat", value);
    cookies.setCookie("vat_price_visibility", value, { expires: date });
  } else {
    // we're loading the default or setting it if it's not there
    if (cookies.getCookie("vat_price_visibility")) {
      document
        .querySelector("body")
        .setAttribute(
          "data-prices-with-vat",
          cookies.getCookie("vat_price_visibility")
        );
      document.querySelector("#vat-prices-selected").value = cookies.getCookie(
        "vat_price_visibility"
      );
    } else {
      cookies.setCookie(
        "vat_price_visibility",
        document.querySelector("#vat-prices-selected").value,
        { expires: date }
      );
      document
        .querySelector("body")
        .setAttribute(
          "data-prices-with-vat",
          document.querySelector("#vat-prices-selected").value
        );
    }
  }
}
if (document.querySelector("#vat-prices-selected")) {
  document
    .querySelector("#vat-prices-selected")
    .addEventListener("change", function (e) {
      setPriceVatVisibility(e.target.value);
    });
  setPriceVatVisibility();
}

var registerForm = document.querySelector(".js-register-form");

if (registerForm) {
  var formContainer = registerForm.querySelector(".register-form__inner");
  var formSubmitBtn = registerForm.querySelector(".register-form__submit");
  var languageInput = registerForm.querySelector('[name="custom[language]"]');

  if (languageInput) {
    function handleWeglotLang() {
      if (typeof window.Weglot !== "undefined") {
        const langCode = window.Weglot.getCurrentLang() || "en";
        console.log(window.Weglot.getCurrentLang());
        languageInput.value = langCode;
      } else {
        setTimeout(handleWeglotLang, 250);
      }
    }

    handleWeglotLang();
  }

  registerForm
    .querySelectorAll('select[name="address[country]"]')
    .forEach((element) => {
      var id = element.id;
      var province = registerForm.querySelector(
        'select[name="address[province]"]'
      );
      var provinceID = province.id;
      var provinceHolderID = province.closest(".form__input-wrapper").id;

      return new Shopify.CountryProvinceSelector(id, provinceID, {
        hideElement: provinceHolderID,
      });
    });

  var vatField = registerForm.querySelector("#register-vat");
  var vatFieldContainer = registerForm.querySelector("#vat-field-container");
  var validateVatBtn = registerForm.querySelector(".js-validate-vat");
  var vatErrorMessage = registerForm.querySelector(".register-form__vat-error");

  vatField.addEventListener("change", function (event) {
    validateVatBtn.disabled = false;
    validateVatBtn.classList.remove("js-success");
    validateVatBtn.classList.remove("js-error");
  });

  if (validateVatBtn) {
    validateVatBtn.addEventListener("click", function () {
      validateVatBtn.classList.add("js-loading");
      validateVatBtn.disabled = true;

      validateVat(vatField.value)
        .then(function (res) {
          console.log(res);
          validateVatBtn.classList.remove("js-loading");

          if (!res.isValid || !res.isValidFormat) {
            validateVatBtn.classList.add("js-error");
          } else if (res.isValid) {
            validateVatBtn.classList.add("js-success");
          }
        })
        .catch(function (error) {
          console.log("catch error", error);
        });
    });
  }

  var checkboxGroups = registerForm.querySelectorAll(
    ".js-checkbox-group.js-required"
  );

  checkboxGroups.forEach(function (group) {
    initCheckboxValidation(group);
  });

  registerForm.addEventListener("submit", function (event) {
    event.preventDefault();

    if (languageInput) {
      handleWeglotLang();
    }

    validateVat(vatField.value)
      .then(function (res) {
        if (!res.isValid || !res.isValidFormat) {
          validateVatBtn.classList.add("js-error");
          vatErrorMessage.style.display = "block";

          return;
        }

        submitRequest();
      })
      .catch(function (error) {
        console.log("catch error", error);
      });

    function submitRequest() {
      var formData = new FormData(event.target);

      let formController = "registerForm";

      if (event.target.classList.contains("js-register-form--update")) {
        formController = "updateForm";
      }

      fetch(`${apiEndpoint}/api/${formController}`, {
        method: "POST",
        credentials: "same-origin",
        body: formData,
        headers: {
          ContentType: "multipart/form-data",
        },
      })
        .then((response) => {
          if (response.ok) return response.json();

          return response.text().then((response) => {
            throw new Error(response);
          });
        })
        .then((data) => {
          if (
            registerForm.getAttribute("data-redirect") &&
            registerForm.getAttribute("data-redirect") !== ""
          ) {
            const redirectURL = registerForm.getAttribute("data-redirect");
            window.open(redirectURL, "_self");
          } else {
            if (formController == "registerForm") {
              var successMessage = registerForm.querySelector(
                ".register-form__message--success"
              );

              formContainer.style.display = "none";
              successMessage.style.display = "block";

              successMessage.scrollIntoView({
                behavior: "instant",
                block: "center",
              });
            } else {
              formSubmitBtn.classList.remove("js-loading");
              formSubmitBtn.classList.add("js-success");
            }
          }
        })
        .catch((error) => {
          console.log(error);

          if (formController == "registerForm") {
            var errorMessage = registerForm.querySelector(
              ".register-form__message--error"
            );

            formContainer.style.display = "none";
            errorMessage.style.display = "block";
            errorMessage.scrollIntoView({
              behavior: "instant",
              block: "center",
            });
          } else {
            formSubmitBtn.classList.remove("js-loading");
            formSubmitBtn.classList.add("js-error");

            var errorMessage = registerForm.querySelector(
              ".register-form__submit-error"
            );
            errorMessage.style.display = "block";
            errorMessage.scrollIntoView({
              behavior: "instant",
              block: "center",
            });
          }
        });
    }
  });

  function validateVat(vatNumber) {
    return fetch(`${apiEndpoint}/api/validateVat`, {
      method: "POST",
      credentials: "same-origin",
      body: JSON.stringify({
        vat: vatNumber,
      }),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        }

        return Promise.reject(Error("error"));
      })
      .catch((error) => {
        return Promise.reject(Error(error.message));
      });
  }

  function initCheckboxValidation(group) {
    var checkboxes = group.querySelectorAll("input[type=checkbox]");
    var checkboxLength = checkboxes.length;
    var firstCheckbox = checkboxLength > 0 ? checkboxes[0] : null;

    if (firstCheckbox) {
      for (let i = 0; i < checkboxLength; i++) {
        checkboxes[i].addEventListener("change", function () {
          var errorMessage = !isChecked(checkboxLength, checkboxes)
            ? "At least one checkbox must be selected."
            : "";
          firstCheckbox.setCustomValidity(errorMessage);
        });
      }

      isChecked(checkboxLength, checkboxes);

      var errorMessage = !isChecked(checkboxLength, checkboxes)
        ? "At least one checkbox must be selected."
        : "";
      firstCheckbox.setCustomValidity(errorMessage);
    }
  }

  function isChecked(checkboxLength, checkboxes) {
    for (let i = 0; i < checkboxLength; i++) {
      if (checkboxes[i].checked) return true;
    }

    return false;
  }
}

const headerDropdowns = document.querySelectorAll(
  ".nav-bar .desktop-menu--wrapper"
);

if (headerDropdowns.length) {
  headerDropdowns.forEach(function (element, index) {
    const dropdownColumnsLength =
      element.querySelectorAll(".navigation__item").length;

    if (dropdownColumnsLength === 1) {
      element.closest(".nav-bar__item").classList.add("js-single-column");
    }
  });
}

const openRegisterPopup = document.querySelectorAll(".js-open-register-popup");

if (openRegisterPopup.length) {
  openRegisterPopup.forEach(function (element, index) {
    element.addEventListener("click", function (event) {
      event.preventDefault();

      document.querySelector(".js-register-popup").classList.add("js-active");
    });
  });
}

const closeRegisterPopup = document.querySelectorAll(
  ".js-close-register-popup"
);

if (closeRegisterPopup.length) {
  closeRegisterPopup.forEach(function (element, index) {
    element.addEventListener("click", function (event) {
      event.preventDefault();

      element.closest(".js-register-popup").classList.remove("js-active");
    });
  });
}

// Collection page: translations for filter app
const gfProducts = document.querySelector(".collection__dynamic-part");
function stockMessageUpdate() {
  const productItems = document.querySelectorAll("#gf-products .product-item");

  productItems.forEach((item) => {
    const productAvailabilityItem = item.querySelector(
      ".product-form__availability"
    );
    const productAvailabilityMessage =
      productAvailabilityItem &&
      productAvailabilityItem.querySelector(
        ".product-form__availability-message"
      );
    const productStock =
      productAvailabilityItem &&
      productAvailabilityItem.getAttribute("data-product-stock");
    if (productAvailabilityMessage) {
      if (productStock > 21) {
        productAvailabilityMessage.innerText = window.languages.inStockHigh;
      } else if (productStock > 5) {
        productAvailabilityMessage.innerText = window.languages.inStockMedium;
      } else if (productStock > 0) {
        productAvailabilityMessage.innerText = window.languages.inStockLow;
      } else {
        productAvailabilityMessage.innerText =
          window.languages.productFormSoldOut;
      }
    }
  });
}

function productsLimitUpdate() {
  const productLimit =
    new URLSearchParams(window.location.search).get("limit") ||
    sessionStorage.getItem("productLimit");
  const productLimitElem = document.querySelector("#setLimit");

  productLimitElem?.addEventListener("change", (e) => {
    sessionStorage.setItem("productLimit", e.target.value);
  });

  if (productLimit && productLimitElem) {
    productLimitElem.value = productLimit;
  }
}

function initCollectionLayout() {
  const productItemElems = document.querySelectorAll(".product-item");
  const collectionLayout = sessionStorage.getItem("collectionLayout");
  const gridLayoutBtn = document.querySelectorAll(
    '.collection__layout-button[data-layout-mode="grid"]'
  );
  const listLayoutBtn = document.querySelectorAll(
    '.collection__layout-button[data-layout-mode="list"]'
  );

  productItemElems?.forEach((elem) => {
    if (collectionLayout == "grid") {
      elem.classList.remove("product-item--list");
      elem.classList.add(
        "product-item--vertical",
        "1/3--tablet-and-up",
        "1/4--desk"
      );
      gridLayoutBtn?.forEach((btn) => {
        btn.classList.add("is-selected");
      });
      listLayoutBtn?.forEach((btn) => {
        btn.classList.remove("is-selected");
      });
    } else {
      elem.classList.remove(
        "product-item--vertical",
        "1/3--tablet-and-up",
        "1/4--desk"
      );
      elem.classList.add("product-item--list");
      gridLayoutBtn?.forEach((btn) => {
        btn.classList.remove("is-selected");
      });
      listLayoutBtn?.forEach((btn) => {
        btn.classList.add("is-selected");
      });
    }
  });
}

let observer = new MutationObserver((changes) => {
  if (
    changes.some((change) =>
      change.target.classList.contains("gf-filter-selection")
    )
  ) {
    productsLimitUpdate();
    initCollectionLayout();
  }

  if (changes.some((change) => change.target.id === "gf-products")) {
    stockMessageUpdate();
    initCollectionLayout();

    const savedProductLimit = sessionStorage.getItem("productLimit");
    if (savedProductLimit && typeof setLimit === "function") {
      setLimit(savedProductLimit);
    }
  }

  if (
    changes.some((change) =>
      change.target.classList.contains("gf-filter-contents")
    )
  ) {
    const productGroupFilterElem = document.querySelector(
      ".gf-option-block--productGroup"
    );
    const topFilterElem = document.querySelector(".gf-filter-contents--top");
    if (productGroupFilterElem && topFilterElem) {
      observer.disconnect();
      topFilterElem.innerHTML = productGroupFilterElem.outerHTML;
    }
  }

  observer.observe(gfProducts, {
    attributes: true,
    childList: true,
    subtree: true,
  });
});

if (gfProducts) {
  observer.observe(gfProducts, {
    attributes: true,
    childList: true,
    subtree: true,
  });
}

const mobileFiltersObserver = new MutationObserver((changes) => {
  if (changes.some((change) => change.target.id === "gf-grid")) {
    if (document.querySelector(".gf-filter-contents--top")) {
      mobileFiltersObserver.disconnect();
      initTopFiltersListener();
    }
  }
});

if (document.querySelector("body.template-collection")) {
  mobileFiltersObserver.observe(
    document.querySelector("body.template-collection"),
    {
      childList: true,
      subtree: true,
    }
  );
}

function initTopFiltersListener() {
  document
    .querySelector(".gf-filter-contents--top")
    .addEventListener("click", (e) => {
      if (e.target.closest("a")) {
        e.target.closest("a").classList.toggle("checked");
      }
    });
}

// Updating the RMA language depending on the Weglot language
function updateLinkRMA() {
  const weglotLanguage = document
    .querySelector(".weglot-container .wgcurrent")
    .getAttribute("data-l");
  const rmaButton = document.querySelector(".order-foot__rma-button");

  if (rmaButton) {
    const orderToken = rmaButton.dataset.orderToken;
    const customerEmail = rmaButton.dataset.customerEmail;
    rmaButton.setAttribute(
      "href",
      `https://rma.4phdepotones.com?token=${orderToken}&email=${customerEmail}&lang=${weglotLanguage}`
    );
  }
}

let rmaObserver = new MutationObserver(updateLinkRMA);

window.addEventListener("DOMContentLoaded", () => {
  const weglotLanguageEl = document.querySelector(
    ".weglot-container .wgcurrent"
  );
  if (weglotLanguageEl) {
    rmaObserver.observe(weglotLanguageEl, {
      attributes: true,
    });
    updateLinkRMA();
  }
});

// Updating the Wholesale Cart Save app's page layout
let saveCartAppObserver = new MutationObserver(() => {
  observer.disconnect();

  const addToCartBtn = document.querySelector(".aod_btn.btn-success");
  const addNewProductBtn = document.querySelector(".aod_add_new_prd_btn");
  const row = addNewProductBtn.closest(".row");
  const mainRow = addNewProductBtn.closest(".flex-row-reverse");
  const subtotalText = document.querySelector(".aodsubtotalText");

  subtotalText.innerHTML = "MY SAVED CART:";
  row.insertBefore(addToCartBtn, addNewProductBtn);
  mainRow.insertBefore(subtotalText, row);
  row.style.flexDirection = "row-reverse";
  mainRow.style.justifyContent = "space-between";
  mainRow.classList.remove("flex-row-reverse");
});

window.addEventListener("DOMContentLoaded", () => {
  const saveCartAppLoader = document.querySelector("#aod_loader");

  if (saveCartAppLoader) {
    saveCartAppObserver.observe(saveCartAppLoader, {
      attributes: true,
    });
  }
});
